import Bugsnag from '@bugsnag/js'
import App from 'next/app';
import Head from 'next/head';
import React from 'react';
import bugsnagStart from '../utils/bugsnag.js'

bugsnagStart()
import Error from './_error';

import 'components/shared/styles/app.scss';
import '../css/style.css';

const ErrorBoundary = process.env.NEXT_PUBLIC_APP_DEBUG === 'false' && process.env.NEXT_PHASE !== "phase-production-build"
  ? Bugsnag.getPlugin('react').createErrorBoundary(React)
  : React.createElement('div');

export default class MyApp extends App {
  render() {
    const { Component, pageProps } = this.props;

    if (process.env.NEXT_PUBLIC_APP_DEBUG === 'true') {
      return (
        <>
          <Head>
            <title>Voiz - Jogtulajdonosok weboffice felület</title>
          </Head>
          <Component {...pageProps} />
        </>
      );
    }
    return (
      <ErrorBoundary FallbackComponent={Error}>
          <Head>
            <title>Voiz - Jogtulajdonosok weboffice felület</title>
          </Head>
          <Component {...pageProps} />
      </ErrorBoundary>
    );
  }
}
